import { render } from "./ManagerMobileNav.vue?vue&type=template&id=bb9089f4"
import script from "./ManagerMobileNav.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ManagerMobileNav.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script